import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Row } from 'antd';
import Button from 'components/Button';
import {
  fetchNotificationApp,
  fetchStatusModalEncaminhar,
  fetchStatusModalJustificativa,
} from 'store/fetchActions/fetchApp';
import {
  fetchAlterarStatusFormulario,
  fetchAlterarStatusSetorial,
  fetchDetalharFormularioPorId,
  fetchAdicionarJustificativa,
} from 'store/fetchActions/fetchFormulario';
import { duckDadosDetalhar } from 'store/ducks/formulario';
import { fetchGetAtendenteByDocumento } from 'store/fetchActions/fetchAtendente';
import { ENUM_MODAL, STATUS_REQUERIMENTO, MSG_INICIAR_ATENDIMENTO, ALERTA } from 'utils/consts';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import { comprovanteRequerimento } from 'routes/paths';
import { fetchGetTodosStatus } from 'store/fetchActions/fetchInputForm';
import { isBloquearButton, filtrarStatus, isShowButtonIniciar } from './detalheServicoDuvida';

export default function FormDetalheButtons({ dados }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const unitaryTests = useSelector(state => state.app.unitaryTests);
  const user = useSelector(state => state.sefaz.userProfile);
  const atendenteLogado = useSelector(state => state.atendente.atendenteLogado);
  const dadosMinimizados = useSelector(state => state.app.dadosMinimizados);
  const listaStatus = useSelector(state => state.status.todosStatus);

  const [bloquearBtn, setBloquearBtn] = useState(false);

  React.useEffect(() => {
    if (unitaryTests) return;
    if (user?.profile !== ENUM_TIPO_PERFIL.CONTRIBUINTE) {
      dispatch(fetchGetAtendenteByDocumento(user?.cpf_cnpj, atendenteLogado));
    }
    // eslint-disable-next-line
  }, [dispatch, user, unitaryTests]);

  React.useEffect(() => {
    const isDisabled = isBloquearButton(dados?.status?.identificador, atendenteLogado);
    setBloquearBtn(isDisabled);
  }, [dados, atendenteLogado]);

  const handleClickEditar = () => {
    if (
      dadosMinimizados.nameModal &&
      dadosMinimizados.nameModal !== ENUM_MODAL.JUSTIFICATIVA.CONTRIBUINTE &&
      dadosMinimizados.nameModal !== ENUM_MODAL.JUSTIFICATIVA.USUARIO_FRENTE &&
      dadosMinimizados.nameModal !== ENUM_MODAL.JUSTIFICATIVA.USUARIO_SETORIAL
    ) {
      dispatch(fetchStatusModalEncaminhar(true, dadosMinimizados.nameModal));
    } else {
      dispatch(fetchStatusModalJustificativa(true, atendenteLogado?.isSetorial));
    }
  };

  const handleEditarContribuinte = () => {
    dispatch(fetchStatusModalJustificativa(true, null, ENUM_MODAL.JUSTIFICATIVA.CONTRIBUINTE));
  };

  const handleSupervisorIniciarAtendimento = () => {
    const objetoJustificativa = {
      justificativa: 'Iniciando Atendimento',
      formularioId: dados?.id,
      atendenteId: atendenteLogado?.id,
      isAtendente: true,
      statusId: STATUS_REQUERIMENTO.EM_ATENDIMENTO.id,
    };
    dispatch(fetchAdicionarJustificativa(objetoJustificativa)).then(() => {
      dispatch(fetchGetTodosStatus(listaStatus, false)).then(todosStatus => {
        const status = filtrarStatus(todosStatus, STATUS_REQUERIMENTO.EM_ATENDIMENTO.identificador);
        dispatch(fetchAlterarStatusFormulario(dados?.id, status?.id)).then(() => {
          dispatch(duckDadosDetalhar({}));
          dispatch(fetchDetalharFormularioPorId(dados?.id));
          fetchNotificationApp(MSG_INICIAR_ATENDIMENTO, '', ALERTA.SUCESSO);
        });
      });
    });
  };

  const handleSupervisorSetorialIniciarAtendimento = () => {
    dispatch(fetchGetTodosStatus(listaStatus, false)).then(todosStatus => {
      const status = filtrarStatus(todosStatus, STATUS_REQUERIMENTO.EM_ATENDIMENTO.identificador);
      const dadosRequest = {
        setorId: dados?.setorId,
        atendenteId: atendenteLogado?.id,
        formularioId: dados?.id,
        statusId: status?.id,
        justificativa: 'Iniciando Atendimento',
      };

      dispatch(fetchAlterarStatusSetorial(dadosRequest)).then(() => {
        dispatch(duckDadosDetalhar({}));
        dispatch(fetchDetalharFormularioPorId(dados?.id));
        fetchNotificationApp(MSG_INICIAR_ATENDIMENTO, '', ALERTA.SUCESSO);
      });
    });
  };

  const renderButtonIniciarAtendimento = () => {
    const isRenderButton = isShowButtonIniciar(user, dados?.status?.identificador);
    return (
      isRenderButton && (
        <Button
          text={'Iniciar Atendimento'}
          clickAction={
            user?.profile === ENUM_TIPO_PERFIL.SUPERVISOR
              ? handleSupervisorIniciarAtendimento
              : handleSupervisorSetorialIniciarAtendimento
          }
          css={{ margin: '5px' }}
        />
      )
    );
  };

  return (
    <Row>
      {user && user?.profile !== ENUM_TIPO_PERFIL.CONTRIBUINTE && (
        <Button text={'Editar'} clickAction={handleClickEditar} css={{ margin: '5px' }} disabled={bloquearBtn} />
      )}
      {(!user || user?.profile === ENUM_TIPO_PERFIL.CONTRIBUINTE) && (
        <>
          {dados?.status?.identificador === STATUS_REQUERIMENTO.DEVOLVIDO_CONTRIBUINTE.identificador && (
            <Button text={'Editar informações'} clickAction={handleEditarContribuinte} css={{ margin: '5px' }} />
          )}
          <Button
            text={'Baixar Comprovante'}
            clickAction={() => history.push(comprovanteRequerimento)}
            css={{ margin: '5px' }}
          />
        </>
      )}
      {renderButtonIniciarAtendimento()}
    </Row>
  );
}

FormDetalheButtons.propTypes = {
  dados: PropTypes.object,
};
